//设置缓存
export const setStorage = (name: string, content: any) => {
  if (!name) return;
  localStorage.setItem(name, JsonStringify(content));
};

//获取缓存
export const getStorage = (name: string) => {
  if (!name) return;
  return JsonParse(localStorage.getItem(name) as string);
};

//清除缓存
export const removeStorage = (name: string) => {
  if (!name) return;
  return localStorage.removeItem(name);
};

const JsonParse = (str: string) => {
  try {
    return JSON.parse(str);
  } catch (e) {
    return str;
  }
};

const JsonStringify = (str: string) => {
  try {
    if (typeof str !== 'string') {
      return JSON.stringify(str);
    }
    return str;
  } catch (e) {
    return str;
  }
};
